module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2zM14 21c0 .552-.432 1-.984 1H12v4h-2v-4h-.984A1.013 1.013 0 0 1 8 21V11c0-.552.462-1 1.016-1H10V6h2v4h1.016c.552 0 .984.448.984 1v10zm10-2c0 .552-.432 1-.984 1H22v6h-2v-6h-.984A1.013 1.013 0 0 1 18 19v-6c0-.552.462-1 1.016-1H20V6h2v6h1.016c.552 0 .984.448.984 1v6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/distribute-horizontal-centers-1.js
// module id = 1098
// module chunks = 14